module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "x-1-chapter-number-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "x-2-ch-title-8"
  }, [_vm._v("Introduction"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tThis book reviews nearly two centuries of Texas Ranger history. During that time, the state and its inhabitants went through many changes. ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', [_vm._v("\tWhen discussing the people, the colony, the republic, the state, and the work of the Rangers, this book refers to the area as it was named during each time period. For example, just prior to the Republic of Texas (1836-45), the region was a part of the Mexican province of Coahuila y Tejas, and the colonies were often identified by a founder’s name (Austin’s Colony, et al.)."), _c('a', {
    attrs: {
      "id": "x.2097"
    }
  })])]), _c('a', {
    attrs: {
      "id": "x.2097"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tPeople of Texas are Texans but they also went by other names. “Texan” can be used for any era, but those who lived in the earliest Texas time were sometimes called Texicans (colonists of Mexico). By the time Texas was an independent country, the people were often called Texians. When the republic became one of the United States, most were simply called Texans. In this book, the old names are used to separate the historic time periods and identify"), _c('span', {
    staticClass: "char-style-override-8"
  }), _vm._v("specific circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tIn many cases, each American Indian group was a tribal nation unto itself. Tribesmen assisted and served with the Rangers as scouts and fighters, a part of the team.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tThe Texas heroes of Mexican heritage also fought for their families, homes, and territory. They are a major part of Texas history, and their sacrifices were many.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tThe black men who first helped in the ranks of the Rangers were sometimes compelled to do so as slaves. Over time, attitudes changed and these men were recognized too. It took longer for them, but their honorable service is remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tWhen the word "), _c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Mexican")]), _vm._v(" is used in this book, it may refer to a citizen of Mexico. But at times the reference is to heritage. The terms "), _c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Hispanic Texan")]), _vm._v(" and "), _c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Mexican American")]), _vm._v(" are also used.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("\tThese terms are used to clearly and respectfully identify the times, places, nations, and people of Texas and its Rangers. The Texas Ranger history is a patchwork quilt of people drawn together to make a blanket of safety.")])])]), _c('a', {
    attrs: {
      "id": "x.2097"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a78910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LONHeFM03.vue
// module id = 63
// module chunks = 0